import { SurveyResults } from "../survey-results/survey-results-types";
import { Survey } from "../surveys/survey-types";
import { CSVOptions, downloadAsCSV } from "./CSVDownloadService";

type ResultRow = {
  questionText: string;
  questionType: string;
  description: string;
  responses: string; // JSON string of ResponseData
  textSummary: string;
  // totalResponses?: number;
};

/**
 * Converts a Survey and its results into a tabular format with one row per question
 */
const convertSurveyResultsToTable = (
  survey: Survey,
  results: SurveyResults
): ResultRow[] => {
  if (survey.id !== results.surveyid) {
    throw new Error("Survey ID mismatch");
  }

  const answersMap = new Map(
    results.aggregatedAnswers.map((answer) => [answer.questionId, answer])
  );

  return survey.questions.map((question) => {
    const answer = answersMap.get(question.id);

    const baseRow: ResultRow = {
      questionText: question.text,
      questionType: question.type,
      description: question.description || "",
      responses: "",
      textSummary: "",
    };

    if (!answer) {
      return baseRow;
    }

    // Handle text questions
    if (answer.textSummary) {
      return {
        ...baseRow,
        textSummary: answer.textSummary,
      };
    }

    // Handle questions with histograms
    if (answer.histogram) {
      return {
        ...baseRow,
        responses: JSON.stringify(answer.histogram),
      };
    }

    return baseRow;
  });
};

function downloadResults(survey: Survey, results: SurveyResults) {
  const data = convertSurveyResultsToTable(survey, results);

  const options: CSVOptions = {
    filename: survey.header.title,
  };
  downloadAsCSV(data, options);
}

export { downloadResults };
export type { ResultRow };
